module.exports = __webpack_public_path__ + "static/media/Video_APP_FIRMA_CAIXABANK_CONSUMER.bacd9168.m4v";